//
// ReportAuxiliary.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../TransportModel";

var ReportAuxiliary = createModule("transport::ReportAuxiliary", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel"], EventDispatcher, [
    ,
    {
        serializeToFile: 2,
        sectionCount: 4,
        finishedGeneratingPreviews: 2,
        generatedPreviewCount: 4,
        textTemplateSummary: 7,
        sectionNames: [7],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default ReportAuxiliary;
